import { Popover } from 'antd';
import classnames from 'classnames';
import React, { useCallback } from 'react';
import { MachinePositionHistoryMapPinPopover } from '../MachinePositionHistoryMapPinPopover/MachinePositionHistoryMapPinPopover';
import { StyledMachinePositionHistoryMapPin } from './MachinePositionHistoryMapPin.styles';
import { MachinePositionHistoryMapPinProps } from './MachinePositionHistoryMapPin.types';
import { ReactComponent as MapMarker } from 'app/assets/images/map/map-marker.svg';

export const MachinePositionHistoryMapPin = ({
  id,
  equipmentPositionSummaries,
  popupContainerRef,
  onClick,
  visible,
  numberOfOrder,
  isClicked,
}: MachinePositionHistoryMapPinProps): JSX.Element => {
  const handleClickMapPinContent = useCallback(
    (event: React.MouseEvent<HTMLDivElement>): void => {
      event.stopPropagation();
      onClick?.(id);
    },
    [id, onClick]
  );

  const pinContent = (): string => {
    let content = numberOfOrder.toString().padStart(2, '0');

    if (equipmentPositionSummaries.length > 1) {
      content = content.concat('+');
    }

    return content;
  };

  return (
    <StyledMachinePositionHistoryMapPin>
      <Popover
        placement="top"
        arrow={false}
        trigger="click"
        open={visible}
        getPopupContainer={(triggerNode): HTMLElement => popupContainerRef ?? triggerNode}
        content={<MachinePositionHistoryMapPinPopover equipmentPositionSummaries={equipmentPositionSummaries} />}
        destroyTooltipOnHide
        overlayClassName="machine-position-history-map-popover-overlay"
        overlayStyle={{ pointerEvents: 'auto' }}
      >
        <div className="machine-position-history-map-pin__content" onClick={handleClickMapPinContent}>
          <div className="machine-position-history-map-pin__marker-container">
            <p
              className={classnames('machine-position-history-map-pin__order-label', {
                'machine-position-history-map-pin__order-label--clicked': isClicked,
              })}
            >
              {pinContent()}
            </p>
            <MapMarker
              className={classnames('machine-position-history-map-pin__map-marker', {
                'machine-position-history-map-pin__map-marker--clicked': isClicked,
              })}
            />
          </div>
        </div>
      </Popover>
    </StyledMachinePositionHistoryMapPin>
  );
};
